import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/smiles_weekly_objective.svg';

export default function ModalsHeaderWeeklyObjective() {

  return (
    <div>
      <div className="ModalsHeader orange">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
